import baseScmService from './baseScmService';

const userAnalyticsProfileService = baseScmService.injectEndpoints({
  endpoints: (build) => ({
    getUserAnalyticsProfile: build.query({
      query: () => ({
        method: 'GET',
        url: '/user-analytics-profiles/current',
      }),
      keepUnusedDataFor: 60 * 60 * 24, // Cache data for 24 hour
    }),
  }),
  overrideExisting: false,
});

export const { useGetUserAnalyticsProfileQuery } = userAnalyticsProfileService;

export default userAnalyticsProfileService;
